import { Settings } from '../../services';
import { createRestSlices, applyReducers } from './rest';
import { ActionPayload } from '..';
import Setting from '../../models/Setting';
import { upsertList } from './remoteUpdate';

const {
    initialState,
    createReducer, startCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,
    duplicateReducer,
    createAction, startCreateAction,
    getAction, listAction,
    updateAction, deleteAction,
    duplicateAction,
} = createRestSlices(Settings);

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    if (type !== 'setting.updated')
        return state;

    return {
        ...state,
        settings: upsertList(state.settings, data, (payload) => new Setting(payload)),
        setting: state.setting?._id === data._id ? new Setting(data) : state.setting
    };
};

/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        duplicateReducer, onRemoteUpdateReducer
    ]);
}

/* Export CRUD actions */
export const createSetting        = createAction;
export const startCreateSetting   = startCreateAction;
export const loadSetting          = getAction;
export const loadSettings         = listAction;
export const updateSetting        = updateAction;
export const deleteSetting        = deleteAction;
export const duplicateSetting     = duplicateAction;
